export function normalizeDocument(value: string): string {
  return value?.toUpperCase().replace(/[^A-Z0-9]/g, '') ?? '';
}

function charValue(c: string): number {
  return c.toUpperCase().charCodeAt(0) - 48;
}

function checkDigit(chars: string): number {
  const w =
    chars.length === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const sum = chars.split('').reduce((a, c, i) => a + charValue(c) * w[i], 0);
  const r = sum % 11;
  return r < 2 ? 0 : 11 - r;
}

export function isValidCnpj(cnpj: string): boolean {
  const c = normalizeDocument(cnpj);
  if (c.length !== 14) return false;
  const body = c.slice(0, 12);
  const dv1 = checkDigit(body);
  const dv2 = checkDigit(body + dv1);
  return c[12] === String(dv1) && c[13] === String(dv2);
}

export function normalizeDocumentInput(
  value: string,
  documentType: string,
): string {
  if (documentType?.toUpperCase() === 'CNPJ') {
    return value.toUpperCase().replace(/[^A-Z0-9]/g, '').trim();
  }
  if (documentType?.toUpperCase() === 'CPF') {
    return value.replace(/[^0-9]/g, '').trim();
  }
  return value.trim();
}
